export const emailFieldName = 'email';
export const acceptedProductNewsEmailsFieldName = 'acceptedProductNewsEmails';
